<template>
  <li role="none">
    <a
      v-if="teaserImageSource"
      class="owc-header-navigation-teaser__link"
      :target="teaserImageLinks.target"
      :href="teaserImageLinks.url"
      :aria-label="teaserImageLinks.aria"
      @click="handleLinkClick"
      data-track="false"
      role="menuitem"
    >
      <ValidationBoxWrapper v-if="isEditMode">
        <slot slot="validation-box" name="validation-box" />
      </ValidationBoxWrapper>
      <GenericImage :imageData="teaserImageSource" :isAuthorEditMode="isEditMode"></GenericImage>
      <p class="owc-header-navigation-teaser__title">{{ teaserImageHeadline }}</p>
    </a>
  </li>
</template>

<script lang="ts">
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import GenericImage from '@owc-packages/GenericImage/src/GenericImage.vue';
import { HeaderNavigationTeaserComponent } from '@owc-packages/Header/src/HeaderNavigationTeaser';
import { FlyoutLevels } from '@owc-packages/Header/src/Header.enums';
import ValidationBoxWrapper from '@owc-packages/ValidationBox/src';

import headerMixin from '@owc-utils/Mixins/Header';
import GenericImageGenerator from '@/packages/_utils/GenericImage/GenericImageGenerator';
import OwcDataComponent from '@owc-utils/Mixins/OwcDataComponent';

export default (ComponentInitializeDispatcher as HeaderNavigationTeaserComponent).extend({
  name: 'owc-header-navigation-teaser',
  mixins: [headerMixin, OwcDataComponent],
  components: {
    GenericImage,
    ValidationBoxWrapper,
  },
  computed: {
    teaserImageLinks() {
      return this.componentData?.link;
    },
    teaserImageHeadline() {
      return this.componentData?.headline;
    },
    teaserImageSource() {
      let componentData: GenericImageGenerator | undefined;

      if (this.componentData?.image) {
        componentData = new GenericImageGenerator(this.componentData.image);
      }

      return componentData;
    },
    currentFlyoutLevel() {
      if (this.componentData?.currentFlyoutLevel) {
        return this.componentData?.currentFlyoutLevel;
      }

      return FlyoutLevels.FLYOUT_LEVEL_ONE;
    },
    nextFlyoutLevel() {
      if (this.currentFlyoutLevel) {
        return this.currentFlyoutLevel + 1;
      }

      return FlyoutLevels.FLYOUT_LEVEL_THIRD;
    },
  },
  methods: {
    handleLinkClick() {
      if (this.teaserImageLinks && this.teaserImageSource && this.teaserImageHeadline) {
        this.addAndSubmitTrackingTree(
          {
            label: this.teaserImageHeadline,
            url: this.teaserImageLinks.url,
          },
          this.nextFlyoutLevel,
        );
      }
    },
  },
});
</script>

<style lang="scss" scoped>
@import '@owc-styles/utils';
@import './styles/flyout-vars';

.owc-header-navigation-teaser {
  &__link {
    @include breakpoint-to(mq4) {
      @include wb-content-width;
    }

    display: block;

    margin-bottom: $flyout-spacing;

    color: var(--wb-grey-20);

    text-decoration: none;

    @include breakpoint-from(mq5) {
      padding: 0;
    }
  }
  &__title {
    @include wb-type-copy;

    margin-top: 16px;

    font-size: 14px;
  }
}
</style>
